import {Injectable} from '@angular/core';

@Injectable()
export class ObjectExportConfig {
  exportUrl?: string;
  jobUrl?: string;
  scope?: string;
}
